import React, { useEffect, useState } from "react";
import { Card, Col, Form, Offcanvas, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsShipmentManagementServices } from "../../../../APIServices/EIWRS/ShipmentManagement/eiwrsShipmentManagementServices";

const ReceivedAtSiteShipment = ({
  shipmentData,
  getStudySiteShipmentData,
  Show,
  Hide,
  Title,
  siteList,
  temperatureList,
  setShipmentId,
}) => {
  const { studyId } = useParams()
  const [temperature, setTemperature] = useState("");
  const [shipmentCondition, setShipmentCondition] = useState("");
  const [comment, setComment] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const receivedAtSiteShipment = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Study Site Shipment!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = shipmentData?._id;
        userData.studyId = studyId;
        userData.temperatureOnReceipt = temperature;
        userData.shipmentCondition = shipmentCondition;
        userData.comment = comment;
        userData.mode = StudyMode;
        let data = await eiwrsShipmentManagementServices.receivedAtSiteShipment(
          userData
        );
        if (data?.statusCode === 200) {
          getStudySiteShipmentData();
          Hide();
          setTemperature("");
          setShipmentCondition("");
          setComment("");
        }
      }
      setButtonLoader(false);
    });
  };
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="mb-3">
            <Card.Body className="p-3">
              <Row>
                <Col xs={6}>
                  <div className="text-muted small">Shipment Number</div>
                  <div className="fw-semibold">{shipmentData?.shipmentNumber}</div>
                </Col>
                <Col xs={6}>
                  <div className="text-muted small">Shipment Type</div>
                  <div className="fw-semibold text-capitalize">{shipmentData?.shipmentType} Shipment</div>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Depot-Site</div>
                  <div className="fw-semibold">{shipmentData?.depot}-{shipmentData?.siteName}</div>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Corier</div>
                  <div className="fw-semibold">{shipmentData?.corier}</div>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Tracking / AWB No.</div>
                  <div className="fw-semibold">{shipmentData?.trackingId}</div>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Temp logger Id</div>
                  <div className="fw-semibold">{shipmentData?.tempLoggerId}</div>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Kits</div>
                  <div className="fw-semibold">
                    {shipmentData?.kitList?.map((item) => (
                      <Form.Check
                        key={item?.kitId}
                        type="checkbox"
                        checked
                        disabled
                        label={`${item?.kitNumber}${item?.columns?.filter(
                          (column) => column?.isUnique === "yes"
                        )?.length > 0
                          ? ` (${item?.columns
                            ?.filter((column) => column?.isUnique === "yes")
                            ?.map(
                              (data) => `${data?.columnName}: ${data?.columnValue}`
                            )
                            ?.join(", ")})`
                          : ""
                          }`}
                      />
                    ))}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Temperature on Receipt <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={temperature}
              onChange={(e) => setTemperature(e.target.value)}
            >
              <option value="">
                Select Temperature
              </option>
              {temperatureList?.map((item, index) => (
                <option key={index} value={item.temperature}>
                  {item.temperature}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Shipiment Condition <abbr className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              value={shipmentCondition}
              onChange={(e) => setShipmentCondition(e.target.value)}
            >
              <option value="">
                Select Shipiment Condition
              </option>
              <option value="damaged">Damaged</option>
              <option value="minorDamaged">Minor Damaged</option>
              <option value="good">Good</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Comment
            </Form.Label>
            <Form.Control
              onChange={(e) => setComment(e.target.value)}
              value={comment}
              className="br3"
              placeholder="Enter Comment"
              as="textarea"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!temperature || !shipmentCondition || buttonLoader}
            className="updateProfile"
            onClick={(e) => receivedAtSiteShipment(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Receiving...
              </div>
            ) : (
              "Receive Shipment"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default ReceivedAtSiteShipment;
